import React from 'react';

import { toUserMembers } from 'app/area/shared/navigation';
import { ButtonPrimary, SectionPanel } from 'ui';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { SubscriberGroupSectionType } from '../metroline/types';
import { UserMembersContainerProps } from 'app/area/subscriber-groups/form/types-store';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';

export const UserMembersContainer: React.FC<UserMembersContainerProps> = ({
  subscriberGroupId, section, infoText, translation, getRef, shouldRenderSection
}) => {

  const onClick = () => toUserMembers(subscriberGroupId);

  return <MetroLineSection<SubscriberGroupSectionType>
    section={section}
    sectionType={SubscriberGroupSectionType.UserMembers}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(SubscriberGroupSectionType.UserMembers)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={SubscriberGroupSectionType.UserMembers}
        validation={undefined}
        info={{
          visible: true,
          text: infoText
        }}
        label={{ visible: true, text: translation.user_members_title }} />
      <MainGridContainer>
        <div className="row">
          <div className="col-12 ">
            <ButtonPrimary
              classNames="mb-3"
              onClick={onClick}>
              {translation.subscriber_groups_user_members}
            </ButtonPrimary>
          </div>
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
